import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { IChatGroupMembers } from 'src/app/model/internalGroupChat.model';
import { IAssignedRole } from 'src/app/service/memeber.model';

@Component({
  selector: 'app-member-info-dialog',
  templateUrl: './member-info-dialog.component.html',
  styleUrls: ['./member-info-dialog.component.css'],
})
export class MemberInfoDialogComponent implements OnInit {
  public name: string;
  constructor(@Inject(MAT_DIALOG_DATA) public memberInformation: IChatGroupMembers) {}

  ngOnInit() {
    this.name = this.memberInformation.memberFirstName
      ? this.memberInformation.memberFirstName
      : null + ' ' + this.memberInformation.memberMiddleName
        ? this.memberInformation.memberMiddleName
        : null + ' ' + this.memberInformation.memberLastName
          ? this.memberInformation.memberLastName
          : null;
  }

  getMemberRoleList(roleDetailList: IAssignedRole[]): string {
    return roleDetailList
      .map((role) => role.roleName)
      .sort()
      .join(', ');
  }
}
